import * as API from '@/api';

export const actions = {
  // R: 取得搜尋相關文章
  async getSearchResult({ commit }, keyword) {
    const searchResult = await API.GET(`/search?keyword=${keyword}`);
    const newSearchResult = JSON.parse(JSON.stringify(searchResult.data)); // Object

    // 濾掉下架
    newSearchResult.artworks = newSearchResult.artworks.filter(artwork => artwork.is_on);
    newSearchResult.temples = newSearchResult.temples.filter(temple => temple.is_on);
    newSearchResult.themes = newSearchResult.themes.filter(theme => theme.is_on);
    newSearchResult.albums = newSearchResult.albums.filter(album => album.is_on);
    newSearchResult.tags = newSearchResult.tags.filter(tag => tag.is_on);

    commit('setSearchResult', newSearchResult);
  },
};